import type { BefundAnzeige, BefundLocale, BefundStufe } from '@projektverwaltung/shared';
import { useTranslation } from 'react-i18next';
import type { BadgeTone } from '../badge.js';

/** Alle Befund-Queries hängen darunter; `invalidateQueries({ queryKey: BEFUNDE_QUERY_KEY })` frischt alles auf. */
export const BEFUNDE_QUERY_KEY = ['befunde'] as const;

/**
 * `info` ist hellblau (eigenes Token `--info`), nicht die Primärfarbe: Das mindsquare-Orange war auf
 * den Karten kaum vom Rot von `kritisch` zu unterscheiden (Nutzertest 2026-09-19).
 */
export const STUFE_TON: Record<BefundStufe, BadgeTone> = {
  info: 'info',
  handeln: 'warn',
  kritisch: 'danger',
};

export const STUFE_FARBE: Record<BefundStufe, string> = {
  info: 'var(--info)',
  handeln: 'var(--warn)',
  kritisch: 'var(--danger)',
};

/** Heutiges Datum als `YYYY-MM-DD` in lokaler Zeit (Vergleich mit `zurueckgestellt_bis`). */
function heuteLokal(): string {
  const d = new Date();
  const zwei = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${zwei(d.getMonth() + 1)}-${zwei(d.getDate())}`;
}

/**
 * Datum, bis zu dem der Befund noch zurückgestellt ist — `null`, wenn er aktiv ist. Abgelaufen zählt
 * wieder als aktiv (dieselbe Regel wie Stapel/Übersicht, serverseitig `istAktiv`).
 */
export function zurueckgestelltBisAktiv(befund: BefundAnzeige): string | null {
  return befund.zustand === 'zurueckgestellt' &&
    befund.zurueckgestellt_bis &&
    befund.zurueckgestellt_bis >= heuteLokal()
    ? befund.zurueckgestellt_bis
    : null;
}

/** Sprache für den serverseitigen Anzeige-Satz (Muster reminder-bar.tsx). */
export function useBefundLocale(): BefundLocale {
  const { i18n } = useTranslation();
  return i18n.language.startsWith('en') ? 'en' : 'de';
}
